<script>
export default {
  name: "HorizontalDivider",
};
</script>

<template>
  <hr class="horizontal-divider" />
</template>

<style scoped lang="scss">
.horizontal-divider {
  display: block;
  border: 0;
  border-top: 0.5px solid var(--theme-color-light);
  width: 100%;
  margin: 0;
  padding: 0;
  margin-block: 0;

  /**
     * Trigger GPU re-render so the border is rendered correctly in the Safari.
     */
  transform: translateZ(0);
  will-change: transform;
}
</style>
